import _ from '@lodash';

const LocationModel = (data) =>
  _.defaults(data || {}, {
    name: '',
    website: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    stateProvince: '',
    postalCode: '',   
  });

export default LocationModel;
